import {
    LOCATION_FAILED,
    LOCATION_FETCHING,
    LOCATION_PROVINCE_SUCCESS,
    LOCATION_DISTRICT_SUCCESS,
    LOCATION_SUBDISTRICT_SUCCESS,
    LOCATION_MOO_SUCCESS,
    LOCATION_COMMUNITY_SUCCESS
} from "../../Constants.ts";

export interface LOCATIONState {
    isFetching: boolean;
    isError: boolean;
    province: any | null;
    district: { data: [] };
    subDistrict: { data: [] };
    moo: { data: [] };
    community: { data: [] },

}

const initialState: LOCATIONState = {
    isFetching: false,
    isError: false,
    province: null,
    district: { data: [] },
    subDistrict: { data: [] },
    moo: { data: [] },
    community: { data: [] },
};

export default (state = initialState, { type, payload }: any): LOCATIONState => {
    switch (type) {
        case LOCATION_FETCHING:
            return { ...state, isFetching: true, isError: false };
        case LOCATION_PROVINCE_SUCCESS:
            return { ...state, isFetching: false, isError: false, province: payload };
        case LOCATION_SUBDISTRICT_SUCCESS:
            return { ...state, isFetching: false, isError: false, subDistrict: payload };
        case LOCATION_DISTRICT_SUCCESS:
            return { ...state, isFetching: false, isError: false, district: payload };
        case LOCATION_MOO_SUCCESS:
            return { ...state, isFetching: false, isError: false, moo: payload };
        case LOCATION_COMMUNITY_SUCCESS:
            return { ...state, isFetching: false, isError: false, community: payload };
        case LOCATION_FAILED:
            return { ...state, isFetching: false, isError: true };
        default:
            return state;
    }
};
